import { createLogic } from 'redux-logic';
import { LOCATION_CHANGE } from 'react-router-redux';
import { API_URL } from '../../../../constants';

import {
  types,
  exportQuotaSuccess,
  exportQuotaError,
} from './index';

const exportQuotaLogic = createLogic({
  type: types.EXPORT_QUOTA,
  cancelType: LOCATION_CHANGE,
  latest: true,

  process({ requestUtil, action }, dispatch, done) {
    const requestURL = `${API_URL}/${action.payload}/quota/export`;
    const opt = {
      method: 'GET',
      responseType: 'blob',
    };
    requestUtil(requestURL, opt).then((success) => {
      dispatch(exportQuotaSuccess(success));
    }).catch((error) => {
      dispatch(exportQuotaError(error));
    }).then(() => done());
  },
});

export default exportQuotaLogic;
